import { KeenIcon } from '@/components';
import { ManageAttach } from './ManageAttach';
import { FormattedMessage } from 'react-intl';

const AttachFiles = ({ isOpen, onToggle }) => {
  return (
    <div>
      <button
        onClick={onToggle}
        className={`w-full flex items-center justify-between py-2 px-4 border border-gray border-opacity-50 
          ${isOpen ? 'bg-gray-200' : 'bg-white'} rounded-md hover:bg-gray-200 transition-colors`}
      >
        <div className='text-sm font-semibold'>
          <KeenIcon icon="paper-clip" className="mr-2" />
          <FormattedMessage id="AGENTS.BUILDER.ATTACH_FILES" />
        </div>
        <span className="text-gray-500">
          {isOpen ? <KeenIcon icon="down" /> : <KeenIcon icon="right" />}
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100 mt-3' : 'max-h-0 opacity-0'
          }`}
      >
        <div className="space-y-2 border rounded-lg">
          <div className="p-3 rounded-lg">
            <ManageAttach />
          </div>
        </div>
      </div>
    </div>
  );
};

export { AttachFiles };
